import React from 'react';
import { withStyles } from '@mui/styles';
import TrplSelect from '../../common/TrplControls/TrplSelect';

import {
  Fab,
  Grid,
  Button,
  Switch,
  TextField,
  Typography,
  Accordion,
  FormControlLabel,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';

import Add from '@mui/icons-material/Add';
import DeleteOutlineOutlined from '@mui/icons-material/DeleteOutlineOutlined';
import ExpandMore from '@mui/icons-material/ExpandMore';

import ComponentWrapper from '../../common/ComponentWrapper';

import Loader from '../../common/Loader';
import CommonStyles from '../../common/CommonStyles';
import ServicesPageStyles from './ServicesPageStyles.js';

import { getRandomInteger } from '../../utils';

const styles = { ...ServicesPageStyles, ...CommonStyles };

class ServicesPage extends ComponentWrapper {
  constructor() {
    super();

    this.state = {
      newService: false,
      newServiceName: '',
      services: [],
      loaded: false,
    };
  }

  componentDidMount() {
    document.title="Services | Milkyweb";

    this.getServices();
  };

  getServices = () => {
    this.get({
      url: '/get_jel?type=["service"]',
      cb: (res) => {
        const services = res.service || [];

        services.forEach((service) => {
          service.methodName = '';
          service.methodUrl = '';
          service.expanded = false;
        });

        this.setState({ services, loaded: true });
      },
    });
  };

  onInputChange = (key, e) => {
    this.setState({ [key]: e.target.value });
  };

  openNewServiceBlock = () => {
    this.setState({ newService: true });
  };

  addNewService = (e) => {
    e.preventDefault();

    const { services, newServiceName } = this.state;

    const service = {
      name: newServiceName,
      methods: [],
      methodName: '',
      methodUrl: '',
    };

    services.push(service);

    this.setState({ services, newService: false, newServiceName: '' });
  };

  onServiceMethodChange = (serviceIndex, methodIndex, key, value) => {
    const { services } = this.state;

    services[serviceIndex].methods[methodIndex][key] = value;

    this.setState({ services });
  };

  addMethodInputChange = (serviceIndex, key, value) => {
    const { services } = this.state;

    services[serviceIndex][key] = value;

    this.setState({ services });
  };

  addNewMethod = (serviceIndex) => {
    const { services } = this.state;
    const service = services[serviceIndex];

    let methodId = getRandomInteger(10000, 99999);
    const method = {
      name: service.methodName,
      url: service.methodUrl,
      return_type: service.methodReturnType,
      contentType: service.methodContentType,
      arguments: service.methodArguments,
    };

    method.id = methodId;

    const isIdExist = (id) => {
      const existingIds = [];

      services.forEach((service) => {
        service.methods.forEach((method) => existingIds.push(method.id));
      });

      if (!existingIds.includes(id)) {
        method.id = id;
        service.methods.push(method);

        service.methodName = '';
        service.methodUrl = '';
        service.methodReturnType = '';
        service.methodContentType = '';
        service.methodArguments = '';

        this.setState({
          services,
        });
      } else {
        isIdExist(getRandomInteger(10000, 99999));
      }
    };

    isIdExist(methodId);
  };

  deleteMethod = (serviceIndex, methodIndex) => {
    const { services } = this.state;

    services[serviceIndex].methods.splice(methodIndex, 1);

    services.forEach((service) => (service.expanded = false));

    this.setState({ services });
  };

  saveService = (serviceIndex) => {
    const { services } = this.state;

    delete services[serviceIndex].methodName;
    delete services[serviceIndex].methodUrl;
    delete services[serviceIndex].methodReturnType;
    delete services[serviceIndex].methodContentType;
    delete services[serviceIndex].methodArguments;
    delete services[serviceIndex].expanded;

    this.postWithData({
      url: `/rest/upd_jel?type=service`,
      data: services[serviceIndex],
      cb: (res) => {
        const { service } = res;

        services[serviceIndex] = service;
        services[serviceIndex].methodName = '';
        services[serviceIndex].methodUrl = '';
        services[serviceIndex].methodReturnType = '';
        services[serviceIndex].methodContentType = '';
        services[serviceIndex].methodArguments = '';
        services[serviceIndex].expanded = true;

        this.setState({ services });
      },
    });
  };

  deleteService = (serviceIndex) => {
    const { services } = this.state;

    if (services[serviceIndex].id) {
      this.get({ url: `/del_jel?id=${services[serviceIndex].id}` });
    }

    services.splice(serviceIndex, 1);

    this.setState({ services });
  };

  toggleExpansionPanel = (serviceIndex) => {
    const { services } = this.state;

    services[serviceIndex].expanded = !services[serviceIndex].expanded;

    this.setState({ services });
  };

  onServiceEnableChange = (serviceIndex, value) => {
    const { services } = this.state;

    services[serviceIndex].enabled = value;

    this.get({
      url: `/enable_jel?id=${services[serviceIndex].id}&enable=${value ? '1' : '0'}`,
      cb: () => {
        this.setState({ services });
      },
      errorCb: () => this.setState({ services }),
    });
  };

  onServiceNameChange = (serviceIndex, value) => {
    const { services } = this.state;

    services[serviceIndex].name = value;

    this.setState({ services });
  };

  contentTypeValues = [
    { title: 'none', value: '' },
    { title: 'aapplication/x-www-form-urlencoded', value: 'application/x-www-form-urlencoded' },
    { title: 'application/json', value: 'application/json' },
    { title: 'application/xml', value: 'application/xml' },
    { title: 'text/plain', value: 'text/plain' },
  ];

  render() {
    const { classes } = this.props;

    const { newService, newServiceName, services, loaded } = this.state;

    return (
      <div className={classes.container}>
        <div className={classes.mb20}>
          {newService ? (
            <form onSubmit={(e) => this.addNewService(e)} className={classes.alignCenter}>
              <TextField
                label="Service name"
                value={newServiceName}
                onChange={(e) => this.onInputChange('newServiceName', e)}
              />

              <Button
                size="small"
                color="primary"
                variant="contained"
                className={classes.ml20}
                disabled={!newServiceName}
                type="submit"
                onClick={(e) => this.addNewService(e)}
              >
                Add
              </Button>
            </form>
          ) : (
            <Button size="small" color="primary" variant="contained" onClick={this.openNewServiceBlock}>
              Add new service
            </Button>
          )}
        </div>

        {!loaded ? (
          <div className={classes.loaderContainer}>
            <Loader />
          </div>
        ) : null}

        {services.length
          ? services.map((service, serviceIndex) => {
              return (
                <Accordion
                  onChange={() => this.toggleExpansionPanel(serviceIndex)}
                  style={{
                    opacity: `${service.enabled ? '1' : '0.5'}`,
                    color: 'black',
                  }}
                  expanded={service.expanded}
                  key={serviceIndex}
                >
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography className={classes.columnHeadingGeneral}>
                      <strong>{service.name}</strong>
                    </Typography>
                  </AccordionSummary>

                  <AccordionDetails className={classes.column}>
                    <TextField
                      className={`${classes.mb20} ${classes.w200}`}
                      value={service.name}
                      title="Title"
                      onChange={(e) => this.onServiceNameChange(serviceIndex, e.target.value)}
                    />

                    <div className={classes.mb20}>
                      <Grid container className={classes.mb10} spacing={2}>
                        <Grid item xs={2}>
                          <span className={classes.gridHeading}>Name</span>
                        </Grid>
                        <Grid item xs={5}>
                          <span className={classes.gridHeading}>Url</span>
                        </Grid>
                        <Grid item xs={1}>
                          <span className={classes.gridHeading}>Return type</span>
                        </Grid>
                        <Grid item xs={2}>
                          <span className={classes.gridHeading}>Content Type</span>
                        </Grid>
                        <Grid item xs={2}>
                          <span className={classes.gridHeading}>Arguments</span>
                        </Grid>
                      </Grid>

                      {service.methods.map((method, methodIndex) => {
                        return (
                          <Grid container className={classes.mb10} spacing={2} key={methodIndex}>
                            <Grid item xs={2}>
                              <TextField
                                fullWidth
                                value={method.name}
                                onChange={(e) =>
                                  this.onServiceMethodChange(serviceIndex, methodIndex, 'name', e.target.value)
                                }
                              />
                            </Grid>

                            <Grid item xs={5}>
                              <TextField
                                fullWidth
                                value={method.url}
                                onChange={(e) =>
                                  this.onServiceMethodChange(serviceIndex, methodIndex, 'url', e.target.value)
                                }
                              />
                            </Grid>

                            <Grid item xs={1}>
                              <TextField
                                fullWidth
                                value={method.return_type}
                                onChange={(e) =>
                                  this.onServiceMethodChange(serviceIndex, methodIndex, 'return_type', e.target.value)
                                }
                              />
                            </Grid>

                            <Grid item xs={2}>
                              <div style={{marginTop: '-8px'}}>
                                <TrplSelect
                                  placeholder='Select Content Type'
                                  complicatedValues
                                  values={this.contentTypeValues}
                                  value={method.contentType || 'none'}
                                  onChange={(e) =>
                                    this.onServiceMethodChange(serviceIndex, methodIndex, 'contentType', e.target.value)
                                  }
                                />
                              </div>
                            </Grid>

                            <Grid item xs={2}>
                              <div className={classes.alignCenter}>
                                <TextField
                                  fullWidth
                                  value={method.arguments}
                                  onChange={(e) =>
                                    this.onServiceMethodChange(serviceIndex, methodIndex, 'arguments', e.target.value)
                                  }
                                />

                                <Fab
                                  size="small"
                                  color="secondary"
                                  style={{ zoom: '0.8', flexShrink: 0 }}
                                  className={classes.ml10}
                                  onClick={() => this.deleteMethod(serviceIndex, methodIndex)}
                                >
                                  <DeleteOutlineOutlined />
                                </Fab>
                              </div>
                            </Grid>
                          </Grid>
                        );
                      })}

                      <Grid container spacing={2}>
                        <Grid item xs={2}>
                          <TextField
                            fullWidth
                            value={service.methodName}
                            onChange={(e) => this.addMethodInputChange(serviceIndex, 'methodName', e.target.value)}
                          />
                        </Grid>

                        <Grid item xs={5}>
                          <TextField
                            fullWidth
                            value={service.methodUrl}
                            onChange={(e) => this.addMethodInputChange(serviceIndex, 'methodUrl', e.target.value)}
                          />
                        </Grid>

                        <Grid item xs={1}>
                          <TextField
                            fullWidth
                            value={service.methodReturnType}
                            onChange={(e) =>
                              this.addMethodInputChange(serviceIndex, 'methodReturnType', e.target.value)
                            }
                          />
                        </Grid>

                        <Grid item xs={2}>
                          <div style={{marginTop: '-8px'}}>
                            <TrplSelect
                              placeholder='Select Content Type'
                              complicatedValues
                              values={this.contentTypeValues}
                              value={service.methodContentType || 'none'}
                              onChange={(e) =>
                                this.addMethodInputChange(serviceIndex, 'methodContentType', e.target.value)
                              }
                            />
                          </div>
                        </Grid>

                        <Grid item xs={2}>
                          <div className={classes.alignCenter}>
                            <TextField
                              fullWidth
                              value={service.methodArguments}
                              onChange={(e) =>
                                this.addMethodInputChange(serviceIndex, 'methodArguments', e.target.value)
                              }
                            />

                            <Fab
                              size="small"
                              color="primary"
                              disabled={!service.methodName || !service.methodUrl}
                              style={{ zoom: '0.8', flexShrink: 0 }}
                              className={classes.ml10}
                              onClick={() => this.addNewMethod(serviceIndex)}
                            >
                              <Add />
                            </Fab>
                          </div>
                        </Grid>
                      </Grid>
                    </div>

                    <div className={classes.spaceBetween}>
                      {service.id ? (
                        <FormControlLabel
                          control={
                            <Switch
                              checked={service.enabled}
                              onChange={(e) => this.onServiceEnableChange(serviceIndex, e.target.checked)}
                              value="Enabled"
                            />
                          }
                          label="Enabled"
                        />
                      ) : null}

                      <div>
                        {service.id ? (
                          <Button
                            size="small"
                            color="secondary"
                            variant="contained"
                            style={{marginRight:'30px'}}
                            onClick={() => this.deleteService(serviceIndex)}
                          >
                            Delete service
                          </Button>
                        ) : null}

                        <Button
                          size="small"
                          color="primary"
                          variant="contained"
                          className={classes.ml10}
                          disabled={!service.name}
                          onClick={() => this.saveService(serviceIndex)}
                        >
                          Save service
                        </Button>
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
              );
            })
          : null}
      </div>
    );
  }
}

export default withStyles(styles)(ServicesPage);
